import styled, { css } from 'styled-components'
import ControlSize, { controlBorderRadius, controlFontSize, controlHeight } from '../../../types/control-size'
import DndComponent from './dnd'

export const Dnd = styled(DndComponent)`
    border-radius: inherit;
`

export const Container = styled.div<{
    controlSize: ControlSize
    disabled: boolean
}>`
    align-items: center;
    display: flex;
    position: relative;
    user-select: none;

    ${({ controlSize, disabled }) => css`
        border-radius: ${controlBorderRadius(controlSize)}px;
        font-size: ${controlFontSize(controlSize)}px;
        height: ${controlHeight(controlSize)}px;

        ${disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
    `}
`
